import { APP_INITIALIZER, inject } from '@angular/core';
import { ConfigStateService, RoutesService } from '@abp/ng.core';
import { ROTA_BASE_ROUTES } from './rota-base.routes';
import { syncRoutesWithFeature } from '../../../shared/routes/feature-routes.util';

export const ROTAS_ROTA_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);
  const configState = inject(ConfigStateService);

  return () => {
    syncRoutesWithFeature(routesService, configState, 'cargo_fleet.Rotas', [...ROTA_BASE_ROUTES]);
  };
}
